export const forcedAppUpdate = {
  'force-update.title': 'It’s time to upgrade',
  'force-update.text':
    'Your app is outdated. Please upgrade to the last app version to enjoy the new Sweetpass benefits!',
  'force-update.cta': 'Upgrade now',
};
